import React from 'react';

import type { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

const ContractInformation = React.lazy(() => import('./views/Information'));
const ContractTerms = React.lazy(() => import('./views/ContractTerms'));
const ContractConsumptionObjects = React.lazy(
  () => import('./views/ConsumptionObjects'),
);
const ContractPriceHistory = React.lazy(() => import('./views/PriceHistory'));
const ContractPlannedVolume = React.lazy(() => import('./views/PlannedVolume'));
const ContractAddenda = React.lazy(() => import('./views/Addenda'));
const ContractDocuments = React.lazy(() => import('./views/Documents'));

export const contractDetailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <ContractInformation />,
  },
  {
    path: Pages.CONTRACT_ADDENDA_PART,
    element: <ContractAddenda />,
  },
  {
    path: Pages.CONSUMPTION_OBJECTS,
    element: <ContractConsumptionObjects />,
  },
  {
    path: Pages.CONTRACT_PLANNED_VOLUME_PART,
    element: <ContractPlannedVolume />,
  },
  {
    path: Pages.CONTRACT_PRICE_HISTORY_PART,
    element: <ContractPriceHistory />,
  },
  {
    path: Pages.CONTRACT_TERMS_PART,
    element: <ContractTerms />,
  },
  {
    path: Pages.CONTRACT_DOCUMENTS_PART,
    element: <ContractDocuments />,
  },
];
